import styled from 'styled-components';
import BaseSwiperSlider from '../BaseSwiperSlider/BaseSwiperSlider';

export const StyledSwiperSlider = styled(BaseSwiperSlider)`
  .swiper-container {
    margin: -10px;
    padding: 10px;
  }
`;
